import React, {Component} from 'react';

import Answer from './Answer'
import DateHandler from './DateHandler'

export default class Question extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pickerVisible: !props.result,
        };
    }

    componentDidMount() {
        const question = this.props.question;

        // if "question" is a result handle it asap
        if (question.type === 'result') {
            this.props.resultHandler(null, question.result, '', '', '', '', '');
        }
    }

    handleAnswerClick = (answer) => {
        this.props.onAnswerClick(answer);
    };

    handleDateChange = (sendDate, printDate, days) => {
        this.setState({
            pickerVisible: false
        });
        var resultHandler = this.props.resultHandler;
        var question = this.props.question;
        var data = {
            "date": sendDate,
            "days": days,
            "ignoreHolidays": question.ignoreHolidays
        };
        if (question.resultDate2) {
            data.extended = true;
        }
        $.ajax({
            type: 'POST',
            url: '/ajax/calculate',
            data: data,
            success: (response) => {
                if (response.date2 !== undefined) {
                    resultHandler(question.ignoreHolidays, question.result, question.resultDate, response.date, printDate, question.resultDate2, response.date2);
                } else {
                    resultHandler(question.ignoreHolidays, question.result, question.resultDate, response.date, printDate);
                }
            },
            error: () => {
                alert('Der skete desværre en fejl, prøv igen senere');
            }
        });
    };

    infoClicked = () => {
        this.setState({
            pickerVisible: true,
        });
        this.props.onInfoClick(this.props.index - 1);
    };

    render() {
        const {
            isLastQuestion,
            result,
            answerText,
            index,
            question: { type, question, answers, days }
        } = this.props;
        // answers for this question should only be visible if it is the last in the list and there is no result
        const answersVisible = isLastQuestion && !result;

        var answersStyle = {
            display: answersVisible ? 'block' : 'none'
        };

        const hintText = answersVisible ? 'Vælg svar nedenfor' : 'Svar: ';
        const indexCheck = answersVisible ? '' : 'check';

        let selectedAnswerText = '';

        if (answerText) {
            selectedAnswerText = answerText;
        }

        // dont render ui if the last "question" is a result (but we still need rest of the question logic to handle the result)
        if (type === 'result') {
            return null;
        }

        return (
            <li className="questionListItem">
                <div className="questionInfo" onClick={this.infoClicked}>
                    <div className={`index ${indexCheck}`}>
                        {index}
                    </div>
                    <div className="question">
                        <p className="question-text">{question}</p>
                        <p className="question-answer">
                            <span className="question-answer-label">{hintText}</span>
                            <span className="question-answer-text" dangerouslySetInnerHTML={{__html: selectedAnswerText}}/>
                        </p>
                    </div>
                </div>
                {type === 'question' &&
                <ul className="answerList" style={answersStyle}>
                    {
                        answers.map((answer, index) => {
                            const indexLetter = String.fromCharCode(97 + index); // gets A, B, C etc.
                            return (
                                <Answer
                                    key={answer.id}
                                    identifier={answer.id}
                                    answer={answer}
                                    onAnswerClick={this.handleAnswerClick}
                                    indexLetter={indexLetter}/>
                            );
                        })
                    }
                </ul>
                }
                {type === 'date' && this.state.pickerVisible ?
                    <DateHandler result={result}
                                 dateChangeCallback={this.handleDateChange}
                                 days={days}/>
                    : null}
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Question.js